// Default-off switch for the options-view trust lines.
// Build: REACT_APP_DOPLE_OPTIONS_TRUST
// Server: DOPLE_OPTIONS_TRUST, delivered as features.options_trust.
// A present server value overrides the build-time flag. Missing means keep the build value.

export const OPTIONS_TRUST_CLIENT_ENV = "REACT_APP_DOPLE_OPTIONS_TRUST";
export const OPTIONS_TRUST_SERVER_ENV = "DOPLE_OPTIONS_TRUST";
export const OPTIONS_TRUST_PAYLOAD_KEY = "options_trust";

const TRUTHY = new Set(["1", "true", "yes", "on"]);

let runtimeOverride = null;
const listeners = new Set();

export function parseOptionsTrustFlag(value) {
  if (value === true) return true;
  return TRUTHY.has(String(value ?? "").trim().toLowerCase());
}

// CRA inlines process.env.REACT_APP_* only for a static member read.
export function readBuildTimeOptionsTrust() {
  return parseOptionsTrustFlag(process.env.REACT_APP_DOPLE_OPTIONS_TRUST);
}

export function optionsTrustEnabled() {
  if (runtimeOverride !== null) return runtimeOverride;
  return readBuildTimeOptionsTrust();
}

function publish() {
  const next = optionsTrustEnabled();
  listeners.forEach((listener) => listener(next));
}

export function applyRuntimeOptionsTrust(payload) {
  if (!payload || typeof payload !== "object") return optionsTrustEnabled();
  const source = payload.features && typeof payload.features === "object" ? payload.features : payload;
  if (!Object.prototype.hasOwnProperty.call(source, OPTIONS_TRUST_PAYLOAD_KEY)) {
    return optionsTrustEnabled();
  }
  runtimeOverride = parseOptionsTrustFlag(source[OPTIONS_TRUST_PAYLOAD_KEY]);
  publish();
  return runtimeOverride;
}

export function subscribeOptionsTrust(listener) {
  listeners.add(listener);
  listener(optionsTrustEnabled());
  return () => listeners.delete(listener);
}

export function resetOptionsTrustForTests() {
  runtimeOverride = null;
  listeners.clear();
}
